// extracted by mini-css-extract-plugin
module.exports = {"markdownStyles":"components-Markdown-styles__markdownStyles"};